module.exports = __webpack_public_path__ + "media/images/ceremony/top/reason5-b585a157dd660ff962aa38d9ceb4de83.jpg";